// src/components/GoToTopButton.jsx
import React from "react";
import { motion } from "framer-motion";
import styles from "./GoToTopButton.module.css";

const GoToTopButton = ({ onClick }) => {
  return (
    <motion.button
      onClick={onClick}
      aria-label="Back to top"
      className={styles.goToTopButton}
      initial={{ opacity: 0, scale: 0.6, y: 16 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.6, y: 16 }}
      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.1, y: -3 }}
      whileTap={{ scale: 0.92 }}
    >
      ↑
    </motion.button>
  );
};

export default GoToTopButton;
